<template>
    <div class="footer-bottom bg-white">
        <CRow class="justify-content-center mb-2">
  <CCol style="display: flex; align-items: center; justify-content: center">
    <CCol sm="12" lg="12">
      <CCol
        sm="12"
        lg="12"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          left: 0;
          right: 0;
          position: fixed;
          bottom: 0px;
          background-color: #fff;
          padding-bottom: 3px;
          padding-top: 5px;
        "
      >
        <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
          <CCol @click="GoHome()">
            <div class="text-center">
              <img src="../assets/img/navigation/navigation/home.png" class="btn-active" style="width: 24px"/>
              <br />
              <label class="text-non-active" style="color:#D0D5DD"> Home</label>
            </div>
          </CCol>
        </CCol>

        <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
          <CCol>
            <div class="text-center">
              <img src="../assets/img/navigation/navigation/search-normal.png" style="width: 24px"/>
              <br />
              <label class="text-non-active" style="color:#D0D5DD"> Search</label>
            </div>
          </CCol>
        </CCol>

        <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1; position: relative;">
          <CCol @click="GoQR()">
            <img 
              src="../assets/img/scan.png" 
              style="
                width: 50px;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid white;
    border-radius: 50%;
              "
            />
          </CCol>
        </CCol>

        <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
          <CCol @click="GoClass()">
            <div class="text-center">
              <img src="../assets/img/navigation/navigation/notification.png" style="width: 24px"/>
              <br />
              <label class="text-non-active" style="color:#D0D5DD"> Notification</label>
            </div>
          </CCol>
        </CCol>

        <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
          <CCol @click="GoClass()">
            <div class="text-center">
              <img src="../assets/img/navigation/navigation/user.png" style="width: 24px"/>
              <br />
              <label class="text-non-active" style="color:#D0D5DD"> Profile</label>
            </div>
          </CCol>
        </CCol>
      </CCol>
    </CCol>
  </CCol>
</CRow>

    </div>
  </template>
  
              
  <script>
  import Vue from "vue";
  
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  
  Vue.use(require("vue-moment"));
  import moment from "moment";
  
  export default {
    components: {
      MainlayoutBottom,
    },
    data: function () {
      return {
       
      };
    },
    async mounted() {
     
    },
    methods: {
     
      GoHome() {
        this.homeclick = true;
        this.homeclickgrey = false;
        this.$router.push("/Home");
        
      },
      GoProfile() {
        if (this.user.userType == "parent") {
          this.profileclick = true;
          this.profileclickgrey = false;
          this.$router.push("/ParentProfile/Profile");
          
        } else {
          this.profileclick = true;
          this.profileclickgrey = false;
          this.$router.push("/Tutor/TutorProfile");
          
        }
      },
      GoQR() {
        this.classclick = true;
        this.classclickgrey = false;
        this.$router.push("HomeSurvey");
      
      },
      GoTutor() {
        this.tutorclick = true;
        this.tutorclickgrey = false;
        this.$router.push("/FindTutor/FindTutorMainpage");
      },
      GoNotification() {
        this.noticlick = true;
        this.noticlickgrey = false;
        this.$router.push("/Notification");
      },
    },
  };
  </script>
  